import { render, staticRenderFns } from "./checkbox-tree.vue?vue&type=template&id=39db3085&"
import script from "./checkbox-tree.vue?vue&type=script&lang=js&"
export * from "./checkbox-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports